// extracted by mini-css-extract-plugin
module.exports = {"Layout":"AuthLayout_Layout__3ts1b","footer":"AuthLayout_footer__2FlMu"};